import { isJunkBox } from './packingSessionDisplay'

// The empaque must come from each packing box, not from the Redux copy: that copy
// is written when the order loads and never follows an empaque change, so labels
// went out quoted with the one the operator had already replaced.

// Junk cajas — closed and empty — are hidden from the operator, so they must not
// claim a package either. The rule (escape hatch included) lives in isJunkBox and
// ONLY there: this file used to carry its own copy of it, and a duplicated copy is
// exactly what let the CUBBO-2690 fix land half-applied — the earlier one patched a
// single call site while four others kept the old inline test. What this one feeds
// is the package list sent to the carrier, so a future divergence bills the wrong
// empaque.
export const shippingUnitsOf = (session, hasNoScannableItems = false) =>
  (session?.packing_boxes || []).filter(box => box && !isJunkBox(box, hasNoScannableItems))

// The serializer only sends the flat id today. The nested read mirrors the two
// resolvers GenerateShipment.js already has for the same value — the restore effect and
// the empaque card — so all three agree
// if that ever changes.
const packageIdOf = box => box?.shipping_package_id ?? box?.shipping_package?.id

// Returns null when the packages cannot be derived — no session, no live boxes, or
// an empaque missing from the catalog — so callers keep the previous behavior
// instead of sending an incomplete list.
//
// `localPackages` are the objects the operator's own selection produced. When one
// of them is the SAME empaque the box holds it wins over the catalog row, because
// a packageless pick keeps its row id while carrying dimensions copied from a
// similar package. A different id means the empaque was changed on the box, which
// is exactly the case this derivation exists to correct.
export const buildLabelPackages = (session, availableShippingPackages, localPackages = [], hasNoScannableItems = false) => {
  const units = shippingUnitsOf(session, hasNoScannableItems)
  if (!units.length) return null

  const catalog = availableShippingPackages || []
  const local = (localPackages || []).filter(Boolean)
  const packages = units.map(unit => {
    const id = packageIdOf(unit)
    // Guard the lookups too: an absent id would match any local slot that has
    // none, and the Redux slice seeds its first slot without one.
    if (!id) return null
    return local.find(pkg => pkg.id === id) || catalog.find(pkg => pkg.id === id) || null
  })
  return packages.every(Boolean) ? packages : null
}

export const withDerivedPackages = (shippingDetails, derivedPackages) =>
  derivedPackages ? { ...shippingDetails, packages: derivedPackages, packages_count: derivedPackages.length } : shippingDetails
